<template>
  <div class="bg-white">
    <CContainer>
      <div class="settings-container">
        <!-- Header -->
        <div class="header-bar">
          <CButton class="back-btn" aria-label="Go back" @click="$router.go(-1)">
            <svg viewBox="0 0 24 24" class="icon-back">
              <line x1="19" y1="12" x2="5" y2="12"></line>
              <polyline points="12 19 5 12 12 5"></polyline>
            </svg>
          </CButton>
          <h2 class="center-title">Settings</h2>
        </div>

        <!-- Profile -->
        <div class="profile-card mt-3">
          <div class="profile-info">
            <img :src="user.filePath" alt="Profile" class="profile-image" />
            <div class="profile-details">
              <h4 class="profile-name font-color-171717">{{ user.name }}</h4>
              <p class="profile-email">{{ user.email }}</p>
            </div>
            <CButton color="light" class="edit-profile border-half" @click="GoEdit">
              Edit profile
            </CButton>
          </div>
        </div>

        <!-- Main Settings -->
        <h3 class="section-title">Main Settings</h3>
        <div class="settings-card">
          <div class="settings-list">
            <SettingItem
              v-if="user.userType === 'company'"
              image="img/new/icondashboard.png"
              label="Dashboard"
              @click="GoToDashboard"
            />

            <SettingItem
              v-if="user.userType === 'company'"
              image="img/new/icondashboard.png"
              label="Cashier Approval"
              @click="GoToCashier"
            />
            <SettingItem image="img/new/crown.png" label="Rewards" @click="GoToRewards" />
            <SettingItem image="img/new/password.png" label="Password" @click="GoToForgot" />
            <SettingItem
              image="img/new/noti-setting.png"
              label="Notification Preferences"
              @click="GoToNotification"
            />
            <SettingItem image="img/new/appear.png" label="Appearance" @click="openAppearance" />
            <SettingItem image="img/new/language.png" label="Language" />
            <SettingItem image="img/new/crown.png" label="Manage Subscriptions" />
            <SettingItem image="img/new/crown.png" label="Payment" />
          </div>
        </div>

        <!-- Support & Feedback -->
        <h3 class="section-title">Support & Feedback</h3>
        <div class="settings-card">
          <div class="settings-list">
            <SettingItem image="img/new/help.png" label="Help Center" @click="GoToHelp" />
            <SettingItem
              image="img/new/help.png"
              label="Help Documentation"
              @click="GoToHelpDoc"
            />
            <SettingItem image="img/new/call2.png" label="Contact Support" @click="GoToContact" />
            <SettingItem image="img/new/call2.png" label="Terms & Conditions" @click="GoToLegal" />
          </div>
        </div>

        <!-- Log Out -->
        <CButton class="logout-button" color="danger" variant="outline" block @click="SignOut">
          Log Out
        </CButton>

        <br /><br /><br /><br />
      </div>

      <!-- Appearance Bottom Sheet -->
      <div
        v-if="showAppearance"
        class="appr-overlay"
        role="dialog"
        aria-modal="true"
        @click.self="closeAppearance"
      >
        <div class="appr-sheet">
          <div class="appr-grabber"></div>
          <h3 class="appr-title">Appearance</h3>

          <button class="appr-option" @click="setTheme('light')">
            <div class="appr-option-head">
              <span class="appr-option-label">Light</span>
              <span class="appr-radio" :class="{ 'is-active': theme === 'light' }"></span>
            </div>
            <p class="appr-option-desc">
              Enjoy a bright and clean interface, perfect for well-lit environments.
            </p>
          </button>

          <button class="appr-option" @click="setTheme('dark')">
            <div class="appr-option-head">
              <span class="appr-option-label">Dark</span>
              <span class="appr-radio" :class="{ 'is-active': theme === 'dark' }"></span>
            </div>
            <p class="appr-option-desc">Easy on the eyes, ideal for low-light settings.</p>
          </button>

          <button class="appr-option" @click="setTheme('system')">
            <div class="appr-option-head">
              <span class="appr-option-label">Follow the System</span>
              <span class="appr-radio" :class="{ 'is-active': theme === 'system' }"></span>
            </div>
            <p class="appr-option-desc">Match the app’s theme to your device’s system settings.</p>
          </button>

          <button class="appr-close" @click="closeAppearance">Close</button>
        </div>
      </div>
    </CContainer>

    <Footerlayout />
  </div>
</template>

<script>
import SettingItem from "@/components/SettingItem.vue";
import Footerlayout from "../containers/TheBottomCustom.vue";

export default {
  name: "SettingsPage",
  components: { SettingItem, Footerlayout },
  data() {
    return {
      user: {},
      showAppearance: false,
      theme: localStorage.getItem("theme") || "system",
    };
  },
  async mounted() {
    try {
      const isAuth = await this.UserAuth();
      if (isAuth) this.GetInfoUser();
      else this.GoToLogin();
    } catch (error) {
      this.GoToLogin?.();
      console.error("Error during authentication:", error);
    }
    this.applyTheme(this.theme);
  },
  methods: {
    async GetInfoUser() {
      try {
        const response = await this.$API.get(this.$LoginUserDetail, { withCredentials: true });
        if (response.status === 200) this.user = response.data;
      } catch (error) {
        console.error("Error fetching user information:", error);
      }
    },
    GoEdit() {
      this.$router.push("ProfileUser");
    },
    GoToForgot() {
      this.$router.push("ForgotPassword");
    },
    GoToNotification() {
      this.$router.push("NotificationSetting");
    },
    GoToHelp() {
      this.$router.push("HelpCenter");
    },
    GoToLegal() {
      this.$router.push("Legal");
    },
    GoToRewards() {
      this.$router.push("HistoryPoint");
    },
    GoToHelpDoc() {
      window.open("https://app.surpriz.ing/customer/support.pdf");
    },
    GoToContact() {
      this.$router.push("ContactUs");
    },
    SignOut() {
      return this.$API
        .get(this.$SignOut, { withCredentials: true })
        .then((res) => res?.status === 200 && this.$router.push("/Login"))
        .catch(() => {});
    },
    GoToLogin() {
      const path = this.$router.currentRoute.path;
      if (path.toLowerCase() !== "/login") {
        this.$router.push({
          path: "/Login",
          query: { targetUrl: this.$router.currentRoute.fullPath },
        });
      }
    },
    GoToDashboard() {
      this.$router.push("DashboardCashier");
    },
    GoToCashier() {
      this.$router.push("Cashier");
    },
    openAppearance() {
      this.showAppearance = true;
    },
    closeAppearance() {
      this.showAppearance = false;
    },
    setTheme(mode) {
      this.theme = mode;
      localStorage.setItem("theme", mode);
      this.applyTheme(mode);
      this.closeAppearance();
    },
    applyTheme(mode) {
      const root = document.documentElement;
      if (mode === "light") root.setAttribute("data-theme", "light");
      else if (mode === "dark") root.setAttribute("data-theme", "dark");
      else root.removeAttribute("data-theme"); // follow system
    },
  },
};
</script>

<style scoped>
/* Header */
.header-bar {
  position: relative;
  height: 52px;
  margin-bottom: 8px;
}
.back-btn {
  position: absolute;
  left: 4px;
  top: 50%;
  transform: translateY(-50%);
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  color: #111827;
  cursor: pointer;
}
.icon-back {
  width: 22px;
  height: 22px;
  stroke: currentColor;
  fill: none;
  stroke-width: 2.5;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.center-title {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #111827;
}

.settings-container {
  padding: 16px 14px 0;
}
.section-title {
  font-size: 16px;
  text-align: left;
  font-weight: 500;
  color: #171717;
  margin: 16px 0 10px;
}

/* Profile card */
.profile-card {
  background: #f3f4f6;
  border-radius: 16px;
}
.profile-info {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 16px;
}
.profile-image {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
}
.profile-details {
  flex: 1;
  text-align: left;
}
.profile-name {
  font-size: 14px;
  font-weight: 600;
  margin: 0;
}
.profile-email {
  font-size: 12px;
  color: #6b7280;
  margin: 2px 0 0;
}
.edit-profile {
  border: 1px solid #e5e7eb !important;
  background: #fff !important;
  color: #111827 !important;
  border-radius: 999px;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 600;
}

/* Group card */
.settings-card {
  background: #f3f4f6;
  border-radius: 16px;
  padding: 8px;
}
.settings-list {
  background: #f3f4f6;
  border-radius: 14px;
  overflow: hidden;
}

/* Style penetrates into SettingItem without mengubah komponennya */
:deep(.setting-item),
:deep(.setting-row) {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  background: transparent;
  position: relative;
}
:deep(.setting-item img),
:deep(.setting-row img) {
  width: 24px;
  height: 24px;
}
:deep(.setting-item .label),
:deep(.setting-row .label) {
  font-size: 14px;
  font-weight: 600;
  color: #171717;
}
/* Chevron kanan */
:deep(.setting-item)::after,
:deep(.setting-row)::after {
  content: "";
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  -webkit-mask: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'><polyline points='9 6 15 12 9 18' fill='none' stroke='%23111827' stroke-width='2.2' stroke-linecap='round' stroke-linejoin='round'/></svg>")
    no-repeat center / contain;
  mask: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'><polyline points='9 6 15 12 9 18' fill='none' stroke='%23111827' stroke-width='2.2' stroke-linecap='round' stroke-linejoin='round'/></svg>")
    no-repeat center / contain;
  background: #111827;
}
/* Divider antar item */
:deep(.setting-item) + :deep(.setting-item),
:deep(.setting-row) + :deep(.setting-row) {
  border-top: 1px solid #e5e7eb;
}

/* Logout button */
.logout-button {
  width: 100%;
  height: 48px;
  border-radius: 999px !important;
  border: 1.5px solid #f04438 !important;
  color: #f04438 !important;
  background: #fff !important;
  font-weight: 700;
  margin-top: 16px;
}

/* Bottom sheet */
.appr-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: flex-end;
  z-index: 999;
}
.appr-sheet {
  width: 100%;
  max-width: 520px;
  margin: 0 auto 12px;
  background: #fff;
  border-radius: 18px;
  padding: 16px;
}
.appr-grabber {
  width: 56px;
  height: 5px;
  border-radius: 999px;
  background: #101828;
  opacity: 0.9;
  margin: 6px auto 10px;
}
.appr-title {
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 6px;
}
.appr-option {
  width: 100%;
  text-align: left;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 12px;
  margin-top: 10px;
}
.appr-option-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.appr-option-label {
  font-weight: 600;
  color: #171717;
}
.appr-radio {
  width: 18px;
  height: 18px;
  border-radius: 999px;
  border: 2px solid #d0d5dd;
  display: inline-block;
}
.appr-radio.is-active {
  border-color: #928afd;
  box-shadow: inset 0 0 0 4px #fff;
  background: #928afd;
}
.appr-option-desc {
  font-size: 12px;
  color: #6b7280;
  margin-top: 4px;
}
.appr-close {
  width: 100%;
  margin-top: 12px;
  border-radius: 12px;
  padding: 12px;
  border: 1px solid #e5e7eb;
  background: #fff;
  font-weight: 600;
}
</style>
